'use client';

import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { toGalleryProseHtml } from '@/utils/galleryProseHtml';

const proseSx = {
  lineHeight: 1.7,
  maxWidth: '100%',
  minWidth: 0,
  overflowWrap: 'break-word',
  wordBreak: 'break-word',
  '& p': { mb: 2 },
  '& h2, & h3, & h4': {
    fontWeight: 600,
    mt: 3,
    mb: 1.5,
  },
  '& ul, & ol': { mb: 2, pl: 3 },
  '& a': {
    color: 'inherit',
    textDecoration: 'underline',
    '&:hover': { opacity: 0.7 },
  },
};

export default function GalleryProseHtml({ html, sx }) {
  const rendered = toGalleryProseHtml(html);
  if (!rendered) {
    return null;
  }

  return <Box sx={[proseSx, sx]} dangerouslySetInnerHTML={{ __html: rendered }} />;
}

GalleryProseHtml.propTypes = {
  html: PropTypes.string,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
};

GalleryProseHtml.defaultProps = {
  html: '',
  sx: undefined,
};
